import api from '../api';
import { tokenService } from '../auth/tokenService';

export const tokensService = {
  getList: async (params) => {
    try {
      const response = await api.get('tokens/packs/', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  create: async (data) => {
    try {
      const response = await api.post('tokens/packs/', data, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  update: async (id, data) => {
    try {
      const response = await api.patch(`tokens/packs/${id}`, data, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  togglePack: async (id, status) => {
    try {
      const response = await api.patch(`tokens/packs/${id}/status`, {
        status,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  deletePack: async (id) => {
    try {
      const response = await api.delete(`tokens/packs/${id}`, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};